import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesVirtual',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { isAlive: true, logicalId: 'virtual' },
    },
  };
};

const DevicesVirtual = props => {
  const defaultProps = {
    title: 'Virtual devices',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesVirtual;
